import angular from 'angular';
import template from './template.html';
import './style.scss';

export class PreviousJobLabel {

}

export const PreviousJobLabelConfigration = {
    template,
    bindings: {
        previousJob: '<'
    },
    controller: PreviousJobLabel,
    controllerAs: 'previousJobLabelCtrl'
};

angular.module('TALENYA-FE').component('previousJobLabel', PreviousJobLabelConfigration);
